import * as React from 'react';
import { useStaticQuery } from 'gatsby';
import { MarkdownBlock } from './markdown-block';
export var ImportMarkdown = function ImportMarkdown(_ref) {
  var className = _ref.className,
      slug = _ref.slug;
  var files = useStaticQuery("1678567308");
  var md = files.allMdx.nodes.find(function (item) {
    return item.fields.slug.includes(slug);
  });
  return /*#__PURE__*/React.createElement(MarkdownBlock, {
    className: className || slug
  }, md.body);
};